module.exports = __webpack_public_path__ + "img/Lock.9f117227.svg";